import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import type { AIManagerQualificationField } from 'src/services/AIManagersService';

export const GOAL_OPTIONS = [
    { id: 'understand_need', label: 'Выяснить задачу' },
    { id: 'confirm_interest', label: 'Подтвердить интерес к предложению' },
    { id: 'collect_phone', label: 'Получить телефон для связи' },
] as const;
export type ManagerGoalId = typeof GOAL_OPTIONS[number]['id'];
export const DEFAULT_MANAGER_GOALS: ManagerGoalId[] = ['understand_need', 'confirm_interest'];
export function normalizeManagerGoals(raw: unknown): ManagerGoalId[] {
    return Array.isArray(raw)
        ? GOAL_OPTIONS.filter(({ id }) => raw.includes(id)).map(({ id }) => id)
        : [...DEFAULT_MANAGER_GOALS];
}
export function fieldsForGoals(fields: AIManagerQualificationField[], goals: ManagerGoalId[]) {
    if (!goals.includes('collect_phone')) return fields.map((field) => field.id === 'phone' ? { ...field, required: false } : field);
    const phone = fields.find((field) => field.id === 'phone' || /телефон/i.test(field.label));
    return phone
        ? fields.map((field) => field === phone ? { ...field, id: 'phone', required: true } : field)
        : [...fields, { id: 'phone', label: 'Телефон для связи', question: 'Какой номер передать для связи?', required: true }];
}
export default function ManagerGoalChecklist({ value, onChange }: {
    value: ManagerGoalId[];
    onChange: (goals: ManagerGoalId[]) => void;
}) {
    return <Box>
        <Typography sx={{ fontSize: 18, fontWeight: 900, mb: 0.5 }}>Результат разговора</Typography>
        <Typography sx={{ color: 'var(--lm-muted)', mb: 0.5 }}>Что нужно выполнить до передачи вам</Typography>
        <Box display="flex" flexDirection="column">
            {GOAL_OPTIONS.map(({ id, label }) => <FormControlLabel key={id} label={label} control={
                <Checkbox checked={value.includes(id)} onChange={(_, checked) =>
                    onChange(checked ? [...value, id] : value.filter((item) => item !== id))} />
            } />)}
        </Box>
    </Box>;
}
